// import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
// import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard implements CanActivate {
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//     return true;
//   }

// }

import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ServiceService } from './services/service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  user_id: any;

  constructor(private auth: AuthService, private router: Router, private ServerService: ServiceService) {
    this.user_id = localStorage.getItem('user_name');
  }

  canActivate(): boolean {
    if (this.auth.isLoggedIn()) {
      if (this.auth.isSessionExpired()) {
        this.auth.logout();
        this.log_details();
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    } else {
      this.log_details();
      this.router.navigate(['/login']);
      return false;
    }
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }

  log_details() {
    const api_req: any = {
      action: "logout",
      phone_number: this.user_id

    };


    this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {
        // success handling
        //console.log("Logout saved successfully");
      } else {
        // error handling
        //console.error("Log saving failed");
      }
    });
  }


}
